import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Star from "@/components/app/Star";
import { media } from "@/utils/breakpoints";

const Icon = styled.div`
  position: absolute;
  left: 10px;
  top: 7px;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1/1;
  border-image-slice: 1;
  z-index: 2;
  transition: transform 1000ms;

  ${media.md`
    left: 12px;
    top: 10px;
  `}

  @supports not (aspect-ratio) {
    width: 29px;
    height: 29px;
  }

  div {
    position: relative;
    transition: transform 1000ms;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 55%;
      height: 55%;
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 1px;
    left: 1px;
    right: 1px;
    bottom: 1px;
    border-radius: 50%;
    background: linear-gradient(180deg, #ea262a 0%, #ea262a 33.85%, #ea262a 64.58%, #ffdbdb 100%);
    -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 0.7px), #fff 0);
  }
`;

const FancyButtonWrapper = styled.a<{ $withIcon?: boolean }>`
  display: inline-block;
  text-decoration: none;
  font-size: 14px;
  line-height: 16px;
  color: black;
  background: rgb(255 255 255 / 20%);
  -webkit-backdrop-filter: blur(80px);
  backdrop-filter: blur(80px);
  border: 1px solid black;
  padding: 12px 18px 14px ${({ $withIcon }) => ($withIcon ? "46" : "20")}px;
  border-radius: 66px;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  ${media.md`
    font-size: 16px;
    padding: 16px 22px 18px 54px;
  `}

  &:hover {
    ${Icon} {
      transform: rotateZ(360deg);

      div {
        transform: rotate(-360deg) rotateY(360deg);
      }
    }
  }
`;

type ButtonProps = {
  children: any;
  className?: string;
  withIcon?: boolean;
  callback?: (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void;
  href?: string;
  focusable?: number;
  target?: "_self" | "_blank" | "_parent" | "_top";
  role?: string,
  ariaDisabled?: boolean
};

export default function FancyButton({
  children,
  className,
  withIcon,
  href = undefined,
  callback,
  focusable,
  target = "_blank",
  role,
  ariaDisabled
}: ButtonProps) {
  const buttonRef = useRef(null);

  useEffect(() => {}, []);
  return (
    <FancyButtonWrapper
      onClick={callback}
      onKeyUp={(e)=>{ if(e.key === 'Enter' && callback) callback(e)}}
      href={href}
      className={className}
      ref={buttonRef}
      $withIcon={withIcon}
      target={target}
      tabIndex={focusable}
      role={role}
      aria-disabled={ariaDisabled}
    >
      {withIcon && (
        <Icon>
          <div>
            <Star />
          </div>
        </Icon>
      )}
      {children}
    </FancyButtonWrapper>
  );
}
